// import React from 'react';
import LoginAccount from '@/views/login/account';
import LoginBind from '@/views/login/bindPhone';
import LoginForgot from '@/views/login/forgot';
import LoginSignUp from '@/views/login/register';
import LoginPhone from '@/views/login/phone';
import LoginReset from '@/views/login/reset';
import LoginVerify from '@/views/login/verify';
import LoginUpgrade from '@/views/login/upgrade';

export const loginRoute = [
  {
    path: '/login/account',
    component: LoginAccount,
    meta: {
      title: '账号登录'
    }
  },
  {
    path: '/login/phone',
    component: LoginPhone,
    meta: {
      title: '手机号登录'
    }
  },
  {
    path: '/login/bindPhone',
    component: LoginBind,
    meta: {
      title: '绑定手机号'
    }
  },
  {
    path: '/login/signUp',
    component: LoginSignUp,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/login/forgot',
    component: LoginForgot,
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/login/verify',
    component: LoginVerify,
    meta: {
      title: '找回账号'
    }
  },
  {
    path: '/login/reset',
    component: LoginReset,
    meta: {
      title: '重置密码'
    }
  },
  {
    path: '/login/upgrade',
    component: LoginUpgrade,
    meta: {
      title: '更新'
    }
  }
];
